import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	ButtonModalParams: {},
	blockContent: {
		top: {
			gap: 'gap-16-24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Нашата история',
					text: 'Повече от 20 години работим с една цел – да направим онлайн присъствието на клиентите по-лесно, сигурно и успешно.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		},
		bottom: {
			gap: 'gap-4-6', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '2005',
					subtitle: `
						<p>Основаване на SuperHosting.BG</p>
						<p>Първи клиент на компанията</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2007',
					subtitle: `
						<p>Първи придобивания на конкурентни компании</p>
						<p>Стартиране на услугите VPS и наети сървъри</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2008',
					subtitle: `
						<p>Участие и награда в Български награди за Web</p>
						<p>Първи и единствен co-marketing партньор на Google за България</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2010',
					subtitle: `
						<p>Национален лидер по брой хоствани домейни</p>
						<p>Награда за цялостен принос в Web бранша</p>
						<p>Официален партньор на Microsoft</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2011',
					subtitle: `
						<p>Официален реселър на .BG домейни</p>
						<p>Миграция към Equinix - най-модерният дейта център в региона</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2013',
					subtitle: `
						<p>Увеличаване на екипа с 30%</p>
						<p>Първи полезни инструменти в cPanel</p>
						<p>Стартиране на услугата Managed VPS</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2014',
					subtitle: `
						<p>Новите домейни (new gTLDs) стават част от портфолиото</p>
						<p>Представяне на платформата за онлайн магазини: Shopiko</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2015',
					subtitle: `
						<p>Нова система за сигурност от хакерски атаки SH Protect</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2016',
					subtitle: `
						<p>Нова хостинг платформа с ALL SSD и цялостна защита</p>
						<p>Нов инструмент в cPanel – Manager for WordPress</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2017',
					subtitle: `
						<p>Придобиване на Host.bg и HostBulgaria</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2019',
					subtitle: `
						<p>Стартиране на услугата Site Builder</p>
						<p>Нова ALL SSD платформа за VPS</p>
						<p>Разширяване на пазара и в Сърбия</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2020',
					subtitle: `
						<p>Разширено присъствие на Балканите.</p>
						<p>Присъединяване към европейската технологична група team.blue</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2021',
					subtitle: `
						<p>Придобиване на компанията ICN.BG</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2024',
					subtitle: `
						<p>Поглед към иновациите с новата услуга Хостинг за WordPress +AI</p>
						<p>Осигуряване на пълна съвместимост с новата услуга GDPR Protect</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2025',
					subtitle: `
						<p>20 години празнуваме бъдещето с нови услуги, 100+ души в екипа и доверие от над 200 000 уебсайта</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		}
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	buttonText: '',
	buttonAction: '',
	buttonParams: [],
	ButtonModal: '',
	ButtonModalParams: {},
	blockContent: {
		top: {
			gap: 'gap-16-24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Our story',
					text: 'For more than 20 years, we have pursued one goal to make our clients’ online presence easier, more secure, and more successful.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		},
		bottom: {
			gap: 'gap-4-6', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '2005',
					subtitle: `
						<p>SuperHosting.BG is founded</p>
						<p>First company client</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2007',
					subtitle: `
						<p>First acquisitions of competing companies</p>
						<p>Launch of VPS and dedicated server services</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2008',
					subtitle: `
						<p>Participation and award at the Bulgarian Web Awards</p>
						<p>First and only Google co-marketing partner in Bulgaria</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2010',
					subtitle: `
						<p>National leader by number of hosted domains</p>
						<p>Award for overall contribution to the web industry</p>
						<p>Official Microsoft Partner</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2011',
					subtitle: `
						<p>Official reseller of .BG domains</p>
						<p>Migration to Equinix, the most advanced data center in the region</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2013',
					subtitle: `
						<p>Team growth of 30%</p>
						<p>First productivity tools introduced in cPanel</p>
						<p>Launch of the Managed VPS service</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2014',
					subtitle: `
						<p>New domains (new gTLDs) added to the portfolio</p>
						<p>Launch of the Shopiko e-commerce platform</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2015',
					subtitle: `
						<p>Introduction of SH Protect — a new security system against hacking attacks</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2016',
					subtitle: `
						<p>New ALL-SSD hosting platform with comprehensive protection</p>
						<p>New cPanel tool: Manager for WordPress/p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2017',
					subtitle: `
						<p>Acquisition of Host.bg and HostBulgaria</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2019',
					subtitle: `
						<p>Launch of the Site Builder service</p>
						<p>New ALL-SSD VPS platform</p>
						<p>Market expansion to Serbia</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2020',
					subtitle: `
						<p>Expanded presence across the Balkans</p>
						<p>Joining the European technology group team.blue</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2021',
					subtitle: `
						<p>Acquisition of ICN.BG</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2024',
					subtitle: `
						<p>Focus on innovation with the new WordPress Hosting + AI service</p>
						<p>Full compatibility ensured with the GDPR Protect service</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				},
				{
					title: '2025',
					subtitle: `
						<p>Celebrating 20 years by looking to the future - with new services, a team of 100+ professionals, and the trust of over 200 000 websites</p>
					`,
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: '',
					ButtonModalParams: {},
				}
			]
		}
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];